import React from 'react'
import AppContext from '../../context'

const Info = ({ title, image, desccription }) => {
    const { setCartOpened } = React.useContext(AppContext);
    return (
        <div className="cartEmpty d-flex align-center justify-center flex-column flex">
            <img className="mb-20" width={120} src={image} alt="Пустая корзина" />
            <h2>{title}</h2>
            <p className="opacity-6">{desccription}</p>
            <button onClick={() => setCartOpened(false)} className="greenButton">
                <img src="/img/arrow.svg" alt="Arrow" />Вернуться назад
            </button>
        </div>
    )
}

export default Info
